import { render, staticRenderFns } from "./MultiSelectionsAnswers.vue?vue&type=template&id=5f64f75a&"
import script from "./MultiSelectionsAnswers.vue?vue&type=script&lang=js&"
export * from "./MultiSelectionsAnswers.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectionsAnswers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports